// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/HomeGenerationOne.vue'),
      },
      {
        path: '/consult',
        name: 'Home General Consult',
        component: () => import('@/views/HomeGeneralConsult.vue'),
      },
      {
        path: '/ai',
        name: 'Home AI Consult',
        component: () => import('@/views/HomeAiConsult.vue'),
      },
      {
        path: '/smile',
        name: 'Home Aligner Consult',
        component: () => import('@/views/HomeAlignerConsult.vue'),
      },
      {
        path: '/web-app',
        name: 'Raw Web App, General Consult',
        component: () => import('@/views/embedded/GenericEmbeddedWidget.vue'),
      },
      {
        path: '*',
        name: 'FourOhFour',
        component: () => import('@/views/404.vue'),
      },
  ],
})

export default router
